import Axios from "axios";
const baseURL = process.env.BARRAMUNDI;

export default {
    getSMSDefaults() {
        return Axios.get(`${baseURL}account/sms-default`).then(res => {
            if (
                res?.data?.response?.message?.code === 200 &&
                res?.data?.response?.resources
            ) {
                return res.data.response.resources;
            }
            return null;
        });
    },
    getSMSDefaultDetail(smsDefaultId) {
        return Axios.get(`${baseURL}account/sms-default/${smsDefaultId}`).then(
            res => {
                if (
                    res?.data?.response?.message?.code === 200 &&
                    res?.data?.response?.resources
                ) {
                    return res.data.response.resources;
                }
                return null;
            }
        );
    },
    updateSMSDefault(smsDefaultId, params) {
        return Axios.put(
            `${baseURL}account/sms-default/${smsDefaultId}`,
            params
        ).then(res => {
            if (
                res?.data?.response?.message?.code === 200 &&
                res?.data?.response?.resources
            ) {
                return res.data.response.resources;
            }
            return null;
        });
    },
    createSMSDefault(params) {
        return Axios.post(`${baseURL}account/sms-default`, params).then(res => {
            if (
                res?.data?.response?.message?.code === 200 &&
                res?.data?.response?.resources
            ) {
                return res.data.response.resources;
            }
            return null;
        });
    }
};
